import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'app/services/auth.service';
import { DataService } from 'app/services/data.service';
import { NotificationService } from 'app/services/notification.service';
import { NoWhitespaceValidator } from 'app/shared/validators/no-whitespace.validator';
import { PasswordComplexityValidator } from 'app/shared/validators/password-complexity.validator';
import { Subscription } from 'rxjs';

declare var $: any;

@Component({
  selector: 'app-user-change-pwd-modal',
  templateUrl: './user-change-pwd-modal.component.html',
  styleUrls: ['./user-change-pwd-modal.component.css']
})
export class UserChangePwdModalComponent implements OnInit, OnDestroy {

  subscription: Subscription;

  type = '';

  formGroup: FormGroup;

  get disableSubmit(): boolean {
    if (this.formGroup) {
      return !this.formGroup.valid;
    }
    return true;
  }

  constructor(private serviceAuth: AuthService,
    private dataService: DataService,
    private notificationService: NotificationService,
    private _fb: FormBuilder,
    private router: Router
  ) { }

  ngOnInit() {
    this.subscription = this.serviceAuth.modal$.subscribe(
      (data) => {
        this.type = data ? data.type : '';
        if (data && data.type == 'FIRST_CHANGE_PWD') {
          this.formGroup.reset();
          $("#changePassModal").modal({ 'backdrop': 'static' });
        }
        if (data && data.type == 'USER_CHANGE_PWD') {
          this.formGroup.reset();
          $("#changePassModal").modal({ 'backdrop': 'static' });
        }
        if (data && data.type == 'EXPIRED_PWD') {
          this.formGroup.reset();
          $("#changePassModal").modal({ 'backdrop': 'static' });
        }
      }
    );

    this.formGroup = this._fb.group({
      current_pwd: ['', [NoWhitespaceValidator()]],
      new_pwd: ['', [PasswordComplexityValidator()]],
      confirm_pwd: ['']
    }, { validator: this.checkPasswords });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  checkPasswords: ValidatorFn = (group: AbstractControl): { [key: string]: any } | null => {
    let password = group.get('new_pwd').value;
    let confirm = group.get('confirm_pwd').value

    if (password !== confirm) {
      group.get('confirm_pwd').setErrors({ passwordMismatch: { message: 'Mật khẩu xác nhận không khớp' } });
      return { passwordMismatch: true };
    }
    return null;
  }

  onFormSubmit() {
    this.dataService.post('account/ChangePassword', {
      OldPassword: this.formGroup.value.current_pwd,
      NewPassword: this.formGroup.value.new_pwd,
      ConfirmPassword: this.formGroup.value.confirm_pwd
    }).subscribe((data) => {
      if (data.Success) {
        this.notificationService.printSuccessMessage(data.Message);
        $("#changePassModal").modal('hide');
        this.router.navigate(['logout']);
      } else {
        this.notificationService.printErrorMessage(data.Message);
      }
    });

  }
}



// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/shared/common-modal/user-change-pwd-modal/user-change-pwd-modal.component.ts